export const getTimeWorkedOnText = (timeWorkedOn) => {
  // Calculate time worked on and construct label
  let hours = timeWorkedOn._Hours;
  let minutes = timeWorkedOn._Minutes;

  // Format minutes
  if (minutes < 10) {
    if (hours !== 0) {
      if (minutes !== 0) minutes = "0" + minutes;
    }
  }

  let timeWorkedOnLabel = "";
  if (hours && minutes) {
    // HOURS AND MINUTES
    timeWorkedOnLabel = `${hours} h ${minutes} min`;
  } else if (hours && !minutes) {
    // HOURS ONLY
    timeWorkedOnLabel = `${hours} h`;
  } else if (!hours && minutes) {
    // MINUTES ONLY
    timeWorkedOnLabel = `${minutes} min`;
  } else {
    // MINUTES ONLY
    timeWorkedOnLabel = `${minutes} min`;
  }

  return timeWorkedOnLabel;
};

export const getMinutesFromMs = (milliseconds) => {
  return Math.floor((milliseconds / 60000) % 60);
};

export const getHoursFromMs = (milliseconds) => {
  return Math.floor((milliseconds / 3600000) % 60);
};
